export const oneToMany = 'oneToMany'

export const manyToMany = 'manyToMany'
